import { Button } from '@/components/ui/Button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import type { RedirectRule } from './redirectTypes'

interface RedirectRuleListProps {
  rules: RedirectRule[]
  warnings: { source: string; message: string }[]
  onEdit: (rule: RedirectRule) => void
  onDelete: (rule: RedirectRule) => void
}

export function RedirectRuleList({ rules, warnings, onEdit, onDelete }: RedirectRuleListProps) {
  const warningsBySource = new Map(warnings.map(warning => [warning.source, warning.message]))
  if (!rules.length) return <p className="text-sm text-muted-foreground">No redirects saved yet.</p>
  return (
    <div className="overflow-x-auto rounded-lg border border-border">
      <table className="w-full text-left text-sm">
        <thead><tr className="border-b border-border"><th className="p-3">Old path</th><th className="p-3">Current path</th><th className="p-3">Status</th><th className="p-3"><span className="sr-only">Actions</span></th></tr></thead>
        <tbody>{rules.map(rule => (
          <tr key={rule.source} className="border-b border-border last:border-0">
            <td className="p-3 font-mono break-all">{rule.source}</td><td className="p-3 font-mono break-all">{rule.destination}{warningsBySource.has(rule.source) && <p className="mt-1 font-sans text-xs text-destructive">{warningsBySource.get(rule.source)}</p>}</td><td className="p-3">{rule.status}</td>
            <td className="p-3 whitespace-nowrap"><Button size="sm" variant="ghost" onClick={() => onEdit(rule)}>Edit</Button>
              <ConfirmDialog title="Remove redirect?" description={`Preview removal of ${rule.source}. The change will take effect after you apply the preview.`}
                trigger={<Button size="sm" variant="ghost">Remove</Button>} confirmText="Preview removal" destructive onConfirm={() => onDelete(rule)} />
            </td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  )
}
